<template>
  <v-alert
    v-model="visible"
    :color="computedColor"
    :title="title"
    :closable="closable"
    @click:close="$emit('close')"
    class="egov-inline-alert"
  >
    <div v-html="description"></div>
    <!-- Icon with dynamic color -->
    <template #prepend>
      <EgovIconButton
        :icon="computedIcon"
        class="remix-icon"
        variant="text"
        size="24"
        tabindex="0"
        aria-hidden="true"
        :iconColor="iconColorMap[props.type]"
      />
    </template>

    <!-- Optional actions slot -->
    <template v-if="$slots.actions" #append>
      <v-btn variant="text" size="small" @click="$emit('action')" class="action-btn">
        <slot name="actions" />
      </v-btn>
    </template>
  </v-alert>
</template>

<script setup>
import { ref, computed } from 'vue'
import EgovIconButton from './EgovIconButton.vue'

const props = defineProps({
  type: {
    type: String,
    default: 'info',
    validator: (value) => ['info', 'success', 'warning', 'error'].includes(value),
  },
  title: { type: String, default: 'Alert' },
  description: { type: String, default: '' },
  closable: { type: Boolean, default: true },
})

const iconMap = {
  info: 'ri-information-fill',
  success: 'ri-checkbox-circle-fill',
  warning: 'ri-alert-fill',
  error: 'ri-error-warning-fill',
}

const iconColorMap = {
  info: '#9ACBFF',
  success: '#4EDDB3',
  warning: '#FFB68F',
  error: '#FFB4AB',
}

const computedColor = computed(() => '#003062')
const computedIcon = computed(() => iconMap[props.type])
const visible = ref(true)
</script>

<style lang="scss">
.egov-inline-alert {
  margin: 8px 0;
  border-radius: 4px !important;
  background-color: #003062 !important;
  color: var(--kds-on-primary) !important;

  .v-alert__content {
    padding-right: 8px;
  }

  a,
  a:visited {
    color: var(--kds-inverse-primary) !important;
  }

  .v-alert__close {
    color: var(--kds-on-primary) !important;
  }

  .action-btn {
    margin-left: 12px;
    text-transform: none;
    letter-spacing: normal;
    color: var(--kds-on-primary) !important;
  }

  .remix-icon {
    font-style: normal;
    font-size: 1.5rem;
    margin-top: 25%;
  }
}
</style>
